import Progress from './progress';
import { withInstall } from '../_util/type';
export { ProgressProps } from './props';
export default withInstall(Progress);